import { __rest } from "tslib";
import clsx from 'clsx';
import React, { forwardRef, memo } from 'react';
const ModalHeader = (_a, ref) => {
    var { className, titleClassName, subtitleClassName, children, toggle, subtitle, tag: Tag = 'h5', wrapTag: WrapTag = 'div', closeAriaLabel = 'Close', charCode = 215, close } = _a, attributes = __rest(_a, ["className", "titleClassName", "subtitleClassName", "children", "toggle", "subtitle", "tag", "wrapTag", "closeAriaLabel", "charCode", "close"]);
    let closeButton;
    const classes = clsx(className, 'modal__header');
    if (!close && toggle) {
        const closeIcon = typeof charCode === 'number' ? String.fromCharCode(charCode) : charCode;
        closeButton = (React.createElement("button", { type: 'button', onClick: toggle, className: 'modal__header__close', "aria-label": closeAriaLabel },
            React.createElement("span", { "aria-hidden": 'true' }, closeIcon)));
    }
    return (React.createElement(WrapTag, Object.assign({}, attributes, { className: classes, ref: ref }),
        React.createElement("div", null,
            React.createElement(Tag, { className: clsx('modal__header__title', titleClassName) }, children),
            subtitle && (React.createElement("span", { className: clsx('modal__header__subtitle', subtitleClassName) }, subtitle))),
        close || closeButton));
};
export default memo(forwardRef(ModalHeader));
//# sourceMappingURL=ModalHeader.js.map